/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-23 09:22:28
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-07-27 17:30:38
 * @name: 工作流对象
 * @Description: 工作流对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\flow\flow.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { workflowVersiongetList,workflowVersiongetVersion, workflowGetList, workflowGetConditions, workflowGetFlowProcess, workflowSaveProcess, workflowDelProcess, workflowSaveLink, workflowDelLink } from '@/api/flow/flow.api.js';
import { apiMethod } from '@/utils/decorator.js';
const flow = class flow {
  constructor() {
    this.options_role = {}; // 角色数组(类数组对象)
    this.options_user = []; // 人员数组
    this.options_condition = []; // 条件数组
    this.options_bill_persons = []; // 业务关联人员可选数组
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取工作流版本列表
   */
  @apiMethod(workflowVersiongetList)
  workflowVersiongetList(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 生成新版本号
   */
   @apiMethod(workflowVersiongetVersion)
   workflowVersiongetVersion(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取工作流列表
   */
  @apiMethod(workflowGetList)
  workflowGetList(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取角色列表
   */
  getOptionsRole() {
    return new Promise((resolve, reject) => {
      let mailList = require("@/object/mailList/mailList.class.js").default;
      let mailListClass = new mailList();
      mailListClass.getRoleList().then(res => {
        this.options_role = res.data;
        resolve(res);
      }).catch(err => {
        reject(err);
      })
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取人员列表
   */
  getOptionsUser() {
    return new Promise((resolve, reject) => {
      let mailList = require("@/object/mailList/mailList.class.js").default;
      let mailListClass = new mailList();
      mailListClass.getAllPeople().then(res => {
        this.options_user = res.data;
        resolve(res);
      }).catch(err => {
        reject(err);
      })
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取连线条件
   * @param {String} flow_id 工作流id
   */
  @apiMethod(workflowGetConditions)
  getOptionsCondition(res) {
    if (res.code === 200) {
      this.options_condition = res.data.conditions;
      this.options_bill_persons = res.data.bill_persons;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取流程步骤和连线信息
   * @param {String} flow_id 工作流id
   */
  @apiMethod(workflowGetFlowProcess)
  workflowGetFlowProcess(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 保存流程步骤
   * @param {String} param 添加信息
   */
  @apiMethod(workflowSaveProcess)
  workflowSaveProcess(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除流程步骤
   * @param {String} param 删除信息
   */
  @apiMethod(workflowDelProcess)
  workflowDelProcess(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 保存连线
   * @param {String} param 连线信息
   */
  @apiMethod(workflowSaveLink)
  workflowSaveLink(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除连线
   * @param {String} param 连线信息
   */
  @apiMethod(workflowDelLink)
  workflowDelLink(res) { }
}

export default flow;